import { render, staticRenderFns } from "./StudentStatusLookup.vue?vue&type=template&id=8529667c&"
import script from "./StudentStatusLookup.vue?vue&type=script&lang=js&"
export * from "./StudentStatusLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports